/* this file is transformed by vux-loader */
/* eslint-disable */
import _classCallCheck from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createClass";
import gcoord from 'gcoord';
export var CoordinateTransformer = /*#__PURE__*/function () {
  function CoordinateTransformer() {
    _classCallCheck(this, CoordinateTransformer);
  }
  _createClass(CoordinateTransformer, null, [{
    key: "toWGS84",
    value:
    // 数据库存的是火星坐标，天地图需要 WGS84
    function toWGS84(lnglat) {
      return gcoord.transform(lnglat, gcoord.GCJ02, gcoord.WGS84);
    }

    // 天地图返回的是 WGS84，存入数据库前转回火星坐标
  }, {
    key: "toGCJ02",
    value: function toGCJ02(lnglat) {
      return gcoord.transform(lnglat, gcoord.WGS84, gcoord.GCJ02);
    }
  }]);
  return CoordinateTransformer;
}();